import React, { useState, useContext, useEffect, useReducer } from 'react';
import { useViewPort } from '../Hooks/useViewPort';
import { AuthContext } from "../../AuthContext";
import { Table } from 'react-bootstrap';
import "../register.css";


const TableRecapData = (props) => {
    const authContext = React.useContext(AuthContext);
    const params = props.params;
    const { width } = useViewPort();
    const breakpoint = 520;

    return width > breakpoint ? <div>
        <Table id="recapUser" className="table_recapUser">
            <thead>
                <th style={{ width: "50%" }}>DataAccount</th>
                <th style={{ width: "50%" }}></th>
                        </thead>
            <tbody>
                <tr>
                    <th style={{ width: "50%" }}>Username :</th>
                    <td style={{ width: "50%" }}>{params.username}</td>
                </tr>
            </tbody>
        </Table>
        <Table id="recapUser" className="table_recapUser">
            <tbody>
                <tr>
                    <th style={{ width: "25%" }}>First Name :</th>
                    <td style={{ width: "25%" }}>{params.firstName}</td>
                    <th style={{ width: "25%" }}>Last Name :</th>
                    <td style={{ width: "25%" }}>{params.lastName}</td>
                </tr>
                <tr>
                    <th style={{ width: "25%" }}>Mail :</th>
                    <td style={{ width: "25%" }}>{params.email}</td>
                    <th style={{ width: "15%" }}>Mail Options :</th>
                    <td style={{ width: "10%" }}>{params.emailOption}</td>
                </tr>
                <tr>
                    <th style={{ width: "25%" }}>Country :</th>
                    <td style={{ width: "25%" }}>{params.country}</td>
                    <th style={{ width: "15%" }}>UTC Zone :</th>
                    <td style={{ width: "10%" }}>{"UTC + " + params.utcOffset}</td>
                </tr>
                <tr>
                    <th style={{ width: "25%" }}>Organization :</th>
                    <td style={{ width: "25%" }}>{params.organisation}</td>
                    <th style={{ width: "25%" }}>Search Type :</th>
                    <td style={{ width: "25%" }}>{params.orgtype}</td>
                </tr>
            </tbody>
        </Table>
    </div> :
        <div>
            <Table id="recapUser" className="table_recapUser">
                <thead>
                    <tr>
                        <th style={{ width: "40%" }}>DataAccount</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ width: "40%" }}>USERNAME :</td>
                        <td style={{ width: "60%" }}>{params.username}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>FIRSTNAME :</td>
                        <td style={{ width: "60%" }}>{params.firstName}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>LASTNAME :</td>
                        <td style={{ width: "60%" }}>{params.lastName}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>MAIL :</td>
                        <td style={{ width: "60%" }}>{params.email}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>Mail Options :</td>
                        <td style={{ width: "60%" }}>{params.emailOption}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>COUNTRY :</td>
                        <td style={{ width: "60%" }}>{params.country}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>UTC ZONE :</td>
                        <td style={{ width: "60%" }}>{"UTC + " + params.utcOffset}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>ORGANIZATION:</td>
                        <td style={{ width: "60%" }}>{params.organisation}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>SEARCH TYPE :</td>
                        <td style={{ width: "60%" }}>{params.orgtype}</td>
                    </tr>
                </tbody>
            </Table>
        </div>

}

export { TableRecapData };